import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle
} from "src/common/components/Card";
import { TextPage } from "src/common/components/Page";
import { useOrgModParams } from "src/features/orgmod";

import "./Information.css";

export const Information: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "ktx" || mod === "kd") {
		return <KtxInformation />;
	}
	return null;
};

const ktxMessages = defineMessages({
	title: {
		id: "information.ktx.title",
		defaultMessage: "Hasznos információk / Szakmai protokollok"
	},
	elitmed: {
		id: "information.ktx.elitmed",
		defaultMessage:
			"Várólistára helyezés szakmai szabályai (HN 2021;25(Suppl.1))"
	},
	ovsz: {
		id: "information.ktx.ovsz",
		defaultMessage: "OVSZ info & dokumentum (2025.06.10)"
	},
	aeek: {
		id: "information.ktx.aeek",
		defaultMessage:
			"Belügyminisztérium egészségügyi szakmai irányelve (2024.08.30. EU kozlony LXXIV(15): 1959–2120.)"
	},
	kdigo: {
		id: "information.ktx.kdigo",
		defaultMessage:
			"Management for kidney transplant candidates (KDIGO 2020)"
	}
});

const KtxInformation: React.FunctionComponent = () => {
	return (
		<TextPage>
			<Card className="information-card">
				<CardHeader>
					<CardTitle>
						<FormattedMessage {...ktxMessages.title} />
					</CardTitle>
				</CardHeader>
				<CardContent>
					<ul>
						<li>
							<a
								href="https://elitmed.hu/kiadvanyaink/hypertonia-es-nephrologia/2021/01+klsz"
								target="_blank"
								rel="noreferrer"
							>
								<FormattedMessage {...ktxMessages.elitmed} />
							</a>
						</li>
						<li>
							<a
								href="https://www.ovsz.hu/hu/kvi/kezeloorvosoknak-dializis-allomasoknak"
								target="_blank"
								rel="noreferrer"
							>
								<FormattedMessage {...ktxMessages.ovsz} />
							</a>
						</li>
						<li>
							<a
								href="https://kollegium.aeek.hu/Dokumentumok/Index"
								target="_blank"
								rel="noreferrer"
							>
								<FormattedMessage {...ktxMessages.aeek} />
							</a>
						</li>
						<li>
							<a
								href="https://kdigo.org/guidelines/transplant-candidate/"
								target="_blank"
								rel="noreferrer"
							>
								<FormattedMessage {...ktxMessages.kdigo} />
							</a>
						</li>
					</ul>
				</CardContent>
			</Card>
		</TextPage>
	);
};
